import { state, res, ui } from './stores.js';

// Memo for expensive game queries made from component templates. One action
// re-renders every Card ~100 times, and each render repeated the same full
// ongoingPlayer() scans. Templates don't change game state, so results are
// shared within one render pass and dropped on any store change or at the end
// of the current microtask (before game logic resumes). Never use this from
// game logic, which can mutate state in place between calls.
let memo = new Map();
let clearQueued = false;
const clear = () => { memo.clear(); clearQueued = false; };
state.subscribe(clear);
res.subscribe(clear);
ui.subscribe(clear);

// True while a displayMemo() computation runs, so shared helpers such as
// ongoingPlayer() can reuse their own results across the cards in one render.
let depth = 0;
export function isDisplaying(){
    return depth > 0;
}

export function displayMemo(key, fn){
    if(memo.has(key)) return memo.get(key);
    let value;
    depth++;
    try {
        value = fn();
    } finally {
        depth--;
    }
    memo.set(key, value);
    if(!clearQueued){
        clearQueued = true;
        queueMicrotask(clear);
    }
    return value;
}
